module.exports = __webpack_public_path__ + "6cad68182d259e6bd12838164cd13de9.png";